module.exports = __webpack_public_path__ + "media/cards/card_selfie_example-68ad4a46.jpg";